module.exports = __webpack_public_path__ + "img/altra_persona.288ac835.svg";